import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Text } from '@nautilusbio/nb-design-system/Text';
import { createLazyFileRoute } from '@tanstack/react-router';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from '../../styles/pages/no_org.module.css';

export const Route = createLazyFileRoute('/no_org/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('noOrg');

  return (
    <Stack alignItems="center" className={styles.container} fullWidth gap={8} justifyContent="center">
      <Text as="h1">{t('title')}</Text>
      <Text as="p">{t('message')}</Text>
    </Stack>
  );
}
